<template>
  <div>
    <v-data-table
      ref="paymentTable"
      v-model="itemsSelectedWithInvoice"
      paginated
      show-select
      dense
      class="main-table"
      height="auto"
      item-key="rowKey"
      loading-text="Cargando... Por favor espere"
      :item-disabled="disableChildSelection"
      :item-class="rowClass"
      :headers="headers"
      :items="items"
    >
      <template #[`header.data-table-select`]="{ props }">
        <div>Exportar a Excel</div>
        <v-simple-checkbox
          :value="itemsSelectedWithInvoice.length > 0"
          :indeterminate="props.indeterminate"
          @input="toggleAllSelection($event)"
        />
      </template>
      <template #[`item.data-table-select`]="{ item, isSelected, select }">
        <v-simple-checkbox
          v-if="isSelectable(item)"
          :value="isSelected"
          @input="select($event)"
        />
      </template>
      <template #[`item.FEPAG`]="{ item }">
        <div v-if="item.isFirstOfPayment == true">
          {{
            removeTimeFromDate(item.FEPAG, displayDateTimeSeconds, displayDate)
          }}
        </div>
      </template>
      <template #[`item.FEDOC`]="{ item }">
        <div>
          {{
            removeTimeFromDate(item.FEDOC, displayDateTimeSeconds, displayDate)
          }}
        </div>
      </template>
      <template #[`item.TOTAL`]="{ item }">
        <div v-if="item.isFirstOfPayment == true">
          {{ formatNumber(item.TOTAL, '$') }}
        </div>
      </template>
      <template #[`item.MONPA`]="{ item }">
        <div>{{ formatNumber(item.MONPA, '$') }}</div>
      </template>
      <template #[`item.TIPO`]="{ item }">
        <div class="d-flex align-items-center">
          <div v-if="!validateIsInserted()" style="min-width: 30px">
            <v-icon
              v-if="item.ADICC && item.ADICC.length > 0"
              small
              color="#5600e8"
              @click="$emit('actionButton', item)"
            >
              {{ item.isOpen ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
            </v-icon>
          </div>
          <span class="w-100">{{ item.TIPO }}</span>
          <div style="min-width: 32px">
            <span
              v-if="item.DOCTO"
              class="badge rounded-pill"
              style="background: #306b75"
              >{{ item.DOCTO }}</span
            >
          </div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';
  import DateFormats from '@/core/constants/DateFormats';
  import dates from '@/mixins/dates.js';

  export default {
    name: 'PaymentHistoryTable',
    mixins: [numbersFormats, dates],
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        headers: [
          { text: 'Fecha de pago', value: 'FEPAG' },
          { text: 'Impte. Pago', value: 'TOTAL' },
          { text: 'Tipo docto.', value: 'TIPO' },
          { text: '# documento', value: 'FACTU' },
          { text: 'Fe. Factura', value: 'FEDOC' },
          { text: 'Impte. Docto.', value: 'MONPA' },
          { text: 'Exportar', value: 'data-table-select' },
        ],
        selectAll: false,
        itemsSelectedWithInvoice: [],
        displayDateTimeSeconds: DateFormats.DISPLAY_DATETIME_SECONDS,
        displayDate: DateFormats.DISPLAY_DATE,
      };
    },
    watch: {
      itemsSelectedWithInvoice(newSelected) {
        const expandedSelection = [];

        newSelected.forEach((parent) => {
          // add father
          expandedSelection.push(parent);

          // get child by  IDPAG
          const children = this.items.filter(
            (item) => item.IDPAG === parent.IDPAG && !item.isFirstOfPayment
          );

          expandedSelection.push(...children);
        });

        // Delete duplicated by rowKey
        const unique = [
          ...new Map(expandedSelection.map((i) => [i.rowKey, i])).values(),
        ];

        this.$emit('itemSelected', unique);
      },
    },
    methods: {
      validateIsInserted() {
        return this.items.inserted;
      },
      rowClass(item) {
        return item.isChild ? 'child-row' : '';
      },
      disableChildSelection(item) {
        return !item.isFirstOfPayment;
      },

      isSelectable(item) {
        return item.isFirstOfPayment;
      },
      toggleAllSelection(value) {
        if (!value) {
          this.itemsSelectedWithInvoice = [];
          if (this.$refs.pagoTable) {
            this.$refs.pagoTable.toggleSelectAll(false);
          }
        } else {
          this.itemsSelectedWithInvoice = this.items.filter((item) =>
            this.isSelectable(item)
          );
        }
      },
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
<style scoped>
  ::v-deep .v-data-table .child-row {
    background-color: #f2f2f2 !important;
  }
</style>
